var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraAnimationDisabled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 11.5v-7c0-.79999.70001-1.5 1.5-1.5h9l.02283.00244-9.77509 9.77509c-.43878-.26807-.74774-.74847-.74774-1.27753zm5.47473 1.5h5.02527c.79999 0 1.5-.70001 1.5-1.5v-.5l4 2v-10l-1.05054.52527z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-1.89949 7.25008h19.79899v1.49984h-19.79899z",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -3.31371 8)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraAnimationDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera-animation-disabled.2440bc93b10bb3d60c20df8ecdb0729a.svg";